import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { TimeEntryTypeViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stLookupApi } from '@/services/st-api';

@Module({ dynamic: true, store, name: 'LookupModule', namespaced: true })
export default class LookupModule extends VuexModule {
  public timeEntryTypes: TimeEntryTypeViewModel[] = [];
  public isLoaded = false;

  @Mutation
  setTimeEntryTypes(types: TimeEntryTypeViewModel[]) {
    this.timeEntryTypes = types;
  }

  @Mutation
  reset() {
    this.isLoaded = false;
  }

  @Mutation
  setIsLoaded(data: boolean) {
    this.isLoaded = data;
  }

  @Action
  async initializeStore() {
    try {
      this.setTimeEntryTypes(await stLookupApi.getTimeEntryTypes());
      this.setIsLoaded(true);
    } catch {
      this.setIsLoaded(false);
    }
  }
}

export const LookupStore = getModule(LookupModule);
